import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import FolderIcon from '@material-ui/icons/Folder';
import { setAppState } from '@cedalo/webui/src/actions/actions';

const mapDispatchToProps = {
	setOpen: (open) => setAppState({ showMachineDataDialog: open })
};

export default connect(
	({ machine }) => ({ machineId: machine.id }),
	mapDispatchToProps
)((props) => {
	return (
		<MenuItem dense onClick={() => props.setOpen(true)}>
			<ListItemIcon>
				<FolderIcon fontSize="default" />
			</ListItemIcon>
			<ListItemText
				primary={<FormattedMessage id="Extensions.Machinedata.Tooltip" defaultMessage="Machine Files" />}
			/>
		</MenuItem>
	);
});



// WEBPACK FOOTER //
// /home/travis/build/cedalo/streamsheets-pro-features/packages/webui-extensions/src/machinedata/MachineDataDownloadMenuItem.js